export var POSITION_SETTINGS = [{
  id: 'top',
  label: 'Top',
  value: 'top'
}, {
  id: 'bottom',
  label: 'Bottom',
  value: 'bottom'
}, {
  id: 'left',
  label: 'Left',
  value: 'left'
}, {
  id: 'right',
  label: 'Right',
  value: 'right'
}];
export var HORIZONTAL_ALIGNMENT_SETTINGS = [{
  id: 'left',
  label: 'Left',
  value: 'left'
}, {
  id: 'center',
  label: 'Center',
  value: 'center'
}, {
  id: 'right',
  label: 'Right',
  value: 'right'
}];
export var VERTICAL_ALIGNMENT_SETTINGS = [{
  id: 'left',
  label: 'Top',
  value: 'left'
}, {
  id: 'center',
  label: 'Middle',
  value: 'center'
}, {
  id: 'right',
  label: 'Bottom',
  value: 'right'
}];